import { render, staticRenderFns } from "./HeroPage.vue?vue&type=template&id=8ec0187e&scoped=true&"
import script from "./HeroPage.vue?vue&type=script&lang=js&"
export * from "./HeroPage.vue?vue&type=script&lang=js&"
import style0 from "./HeroPage.vue?vue&type=style&index=0&id=8ec0187e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec0187e",
  null
  
)

export default component.exports